module.exports = __webpack_public_path__ + "img/light.e08882c7.svg";